import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../service.service';
import { CommonFunctionsService } from '../functions/common-functions.service';
import Swal from 'sweetalert2';
import { Location } from '@angular/common';

@Component({
  selector: 'app-factory-projection-listing',
  templateUrl: './factory-projection-listing.component.html',
  styleUrls: ['./factory-projection-listing.component.css']
})
export class FactoryProjectionListingComponent implements OnInit {

  searchdata = {
    year_month: '',
    created_by_id: ''
  }
  count: number = 0;
  Newcount:number = 0
  constructor(private productService: ServiceService, private route: ActivatedRoute, private router: Router,private commonfunc:CommonFunctionsService,private locate : Location) { }
  output: any
  next_output:any
  ngOnInit(): void {
    var date = new Date()
    var getmonth = (date.getMonth() + 1).toString().padStart(2, '0');
    var getYear = date.getFullYear()
    this.searchdata.year_month = `${getYear}-${getmonth}`

    this.listing()
  }

  listing() {
    this.next_output = []
    var search_string = `offset=${this.count}&year_month=${this.searchdata.year_month}&created_by_id=${this.searchdata.created_by_id}` 
    this.productService.factoryProductionListing(search_string).subscribe((res) => {
      this.output = res.data
      console.log("message=", this.output)
    })
  }

  clicks_next() {
    if (this.count >= 0 && this.output.length != 0) {
      this.count++;
      this.Newcount = this.count;
      this.listing();
    } else {
      if (this.Newcount < this.count) {
        this.count--;
      }
      return;
    }
  }

  /**
   * Handles click on previous button for pagination.
   */
  clicks_previous() {
    if (this.count >= 1) {
      this.count--;
      this.Newcount = this.count;
      this.listing();
    } else {
      return;
    }
  }

  dateChange(){
    console.log(this.searchdata)
    this.listing()
  }

  checkedList: any = []
  allChecked: boolean = false
  deletingData = {
    ids : this.checkedList
  }

  CheckedAll_box(event: any) {
    const checkedFunctionValue = this.commonfunc.CheckedAll_box(event, this.output)
    this.allChecked = checkedFunctionValue.allChecked
    this.checkedList = checkedFunctionValue.checkedList
    this.deletingData.ids = this.checkedList
  }

  Checked_box(value: any, event: any) {
    const indvChecked = this.commonfunc.Checked_box(value, event)
    this.checkedList = indvChecked
    console.log(this.checkedList)
    this.deletingData.ids = this.checkedList

  }

  Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.onmouseenter = Swal.stopTimer;
      toast.onmouseleave = Swal.resumeTimer;
    }
  });
  deleteConfirm() {
    if (this.checkedList.length == 0) {
      this.Toast.fire({
        icon: "error",
        title: "Select any item"
      });
    }
    else {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then((result) => {
        if (result.isConfirmed) {
          console.log(this.deletingData);
          
          const subscription = this.productService.factoryProductionDelete(this.deletingData).subscribe((res) => {
            if (res.success) {
              Swal.fire({
                title: "Deleted!",
                text: "Your file has been deleted.",
                icon: "success"
              });
              this.commonfunc.alertFunction('Deleted', 'Your file has been deleted.', 'success')
              this.allChecked=false
            }
            else {
              this.commonfunc.alertFunction('Not Deleted', 'Your file is not deleted.', 'error')
            }
            this.listing()
            // window.reload
            // var clone = {
            //   srcElement:{
            //     checked : false
            //   }
            // }
            // this.CheckedAll_box(clone)
          },
          );
          // this.subscriptions.push(subscription);
          this.listing()
        }
      })
    }
  }

  ngOnDestroy(): void {
    this.commonfunc.checkedList = []
    this.commonfunc.allChecked = false
  }



}
